module.exports = __webpack_public_path__ + "static/media/uniprid_8g.cda2ad0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pina/climasense/barrenador_pinha/curativa/uniprid_8g.png
// module id = 2292
// module chunks = 3